<template>
    <div class="flex flex-wrap items-center h-full" 
    :class="align"
    >
        <button
        :class="classButton ? classButton : `${fill} ${color} ${border} text-1.6rem px-8 border max-w-md py-3 cta-footer mb-4`"
        @click.prenvent="toggleSidebar()" >{{content}}</button>
    </div>
    <div v-if="openFormFooter" class="fixed right-0 h-screen top-0 w-full lg:w-1/5 bg-[#313131] z-500">
        <div class="close-sidebar justify-end flex">
            <button class="text-2xl p-4 text-white"
            @click.prenvent="toggleSidebar()"
            >
                <i class="fa fa-close"></i>
            </button>
        </div>
        <div class="wrap-form-footer p-4 py-16 mb-4 ">
            <div class="title-form">
                <h3 class="text-white">CONTATTACI</h3>
                <div class="sub-title text-lg text-white">
                    Per maggiori info compila il form e inviaci un messaggio.
                </div>
            </div>
            <div class="mt-20 wrap-contatti">
            <form-contatti />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name:'contact-form-footer',
    props:{
        fill:{
            type:String,
            default: 'hover:bg-white bg-black'
        },
        color:{
            type:String,
            default: 'text-white hover:text-black'
        },
        border:{
            type:String,
            default: 'border-white'
        },
        content:{
            type:String,
            default:'CONTATTACI'
        },
        align:{
            type:String,
            default:'justify-center'
        },
        classButton:{
            type:String,
            default:''
        }
    },
    setup () {
        

        return {}
    },
    data(){
        return{
            openFormFooter:false
        }
    },
    methods:{
        toggleSidebar(){
            this.openFormFooter = !this.openFormFooter
            document.querySelector('body').classList.toggle('scroll-lock');
        },
    },
    mounted(){
        console.log(this.content)
    }
}
</script>

<style lang="scss" scoped>
.cta-footer{
    letter-spacing: 1px;
}
.wrap-contatti{
    height:calc(100vh - 200px);
    overflow-y: scroll;
   
}

</style>